module.exports = __webpack_public_path__ + "static/media/05_TATA CP@3x.f96dcce6.png";